export const currency =[
  {"symbol":"","name":"-----"},
  {"symbol":"\u062f.\u0625;","name":"UAE dirham"},
  {"symbol":"Afs","name":"Afghan afghani"},
  {"symbol":"L","name":"Albanian lek"},
  {"symbol":"AMD","name":"Armenian dram"},
  {"symbol":"NA\u0192","name":"Netherlands Antillean gulden"},
  {"symbol":"Kz","name":"Angolan kwanza"},
  {"symbol":"$","name":"Argentine peso"},
  {"symbol":"$","name":"Australian dollar"},
  {"symbol":"\u0192","name":"Aruban florin"},
  {"symbol":"AZN","name":"Azerbaijani manat"},
  {"symbol":"KM","name":"Bosnia and Herzegovina konvertibilna marka"},
  {"symbol":"Bds$","name":"Barbadian dollar"},
  {"symbol":"\u09f3","name":"Bangladeshi taka"},
  {"symbol":"BGN","name":"Bulgarian lev"},
  {"symbol":".\u062f.\u0628","name":"Bahraini dinar"},
  {"symbol":"FBu","name":"Burundi franc"},
  {"symbol":"BD$","name":"Bermudian dollar"},
  {"symbol":"B$","name":"Brunei dollar"},
  {"symbol":"Bs.","name":"Bolivian boliviano"},
  {"symbol":"R$","name":"Brazilian real"},
  {"symbol":"B$","name":"Bahamian dollar"},
  {"symbol":"Nu.","name":"Bhutanese ngultrum"},
  {"symbol":"P","name":"Botswana pula"},
  {"symbol":"Br","name":"Belarusian ruble"},
  {"symbol":"BZ$","name":"Belize dollar"},
  {"symbol":"$","name":"Canadian dollar"},
  {"symbol":"F","name":"Congolese franc"},
  {"symbol":"Fr.","name":"Swiss franc"},
  {"symbol":"$","name":"Chilean peso"},
  {"symbol":"\u00a5","name":"Chinese/Yuan renminbi"},
  {"symbol":"Col$","name":"Colombian peso"},
  {"symbol":"\u20a1","name":"Costa Rican colon"},
  {"symbol":"$","name":"Cuban peso"},
  {"symbol":"Esc","name":"Cape Verdean escudo"},
  {"symbol":"K\u010d","name":"Czech koruna"},
  {"symbol":"Fdj","name":"Djiboutian franc"},
  {"symbol":"Kr","name":"Danish krone"},
  {"symbol":"RD$","name":"Dominican peso"},
  {"symbol":"\u062f.\u062c","name":"Algerian dinar"},
  {"symbol":"KR","name":"Estonian kroon"},
  {"symbol":"\u00a3","name":"Egyptian pound"},
  {"symbol":"Nfa","name":"Eritrean nakfa"},
  {"symbol":"Br","name":"Ethiopian birr"},
  {"symbol":"\u20ac","name":"European Euro"},
  {"symbol":"FJ$","name":"Fijian dollar"},
  {"symbol":"\u00a3","name":"Falkland Islands pound"},
  {"symbol":"\u00a3","name":"British pound"},
  {"symbol":"GEL","name":"Georgian lari"},
  {"symbol":"GH\u20b5","name":"Ghanaian cedi"},
  {"symbol":"\u00a3","name":"Gibraltar pound"},
  {"symbol":"D","name":"Gambian dalasi"},
  {"symbol":"FG","name":"Guinean franc"},
  {"symbol":"CFA","name":"Central African CFA franc"},
  {"symbol":"Q","name":"Guatemalan quetzal"},
  {"symbol":"GY$","name":"Guyanese dollar"},
  {"symbol":"HK$","name":"Hong Kong dollar"},
  {"symbol":"L","name":"Honduran lempira"},
  {"symbol":"kn","name":"Croatian kuna"},
  {"symbol":"G","name":"Haitian gourde"},
  {"symbol":"Ft","name":"Hungarian forint"},
  {"symbol":"Rp","name":"Indonesian rupiah"},
  {"symbol":"\u20aa","name":"Israeli new sheqel"},
  {"symbol":"\u20B9","name":"Indian rupee"},
  {"symbol":"\u062f.\u0639","name":"Iraqi dinar"},
  {"symbol":"IRR","name":"Iranian rial"},
  {"symbol":"kr","name":"Icelandic kr\u00f3na"},
  {"symbol":"J$","name":"Jamaican dollar"},
  {"symbol":"JOD","name":"Jordanian dinar"},
  {"symbol":"\u00a5","name":"Japanese yen"},
  {"symbol":"KSh","name":"Kenyan shilling"},
  {"symbol":"\u0441\u043e\u043c","name":"Kyrgyzstani som"},
  {"symbol":"\u17db","name":"Cambodian riel"},
  {"symbol":"KMF","name":"Comorian franc"},
  {"symbol":"W","name":"North Korean won"},
  {"symbol":"W","name":"South Korean won"},
  {"symbol":"KWD","name":"Kuwaiti dinar"},
  {"symbol":"KY$","name":"Cayman Islands dollar"},
  {"symbol":"T","name":"Kazakhstani tenge"},
  {"symbol":"KN","name":"Lao kip"},
  {"symbol":"\u00a3","name":"Lebanese lira"},
  {"symbol":"Rs","name":"Sri Lankan rupee"},
  {"symbol":"L$","name":"Liberian dollar"},
  {"symbol":"M","name":"Lesotho loti"},
  {"symbol":"Lt","name":"Lithuanian litas"},
  {"symbol":"Ls","name":"Latvian lats"},
  {"symbol":"LD","name":"Libyan dinar"},
  {"symbol":"MAD","name":"Moroccan dirham"},
  {"symbol":"MDL","name":"Moldovan leu"},
  {"symbol":"FMG","name":"Malagasy ariary"},
  {"symbol":"MKD","name":"Macedonian denar"},
  {"symbol":"K","name":"Myanma kyat"},
  {"symbol":"\u20ae","name":"Mongolian tugrik"},
  {"symbol":"P","name":"Macanese pataca"},
  {"symbol":"UM","name":"Mauritanian ouguiya"},
  {"symbol":"Rs","name":"Mauritian rupee"},
  {"symbol":"Rf","name":"Maldivian rufiyaa"},
  {"symbol":"MK","name":"Malawian kwacha"},
  {"symbol":"$","name":"Mexican peso"},
  {"symbol":"RM","name":"Malaysian ringgit"},
  {"symbol":"MTn","name":"Mozambican metical"},
  {"symbol":"N$","name":"Namibian dollar"},
  {"symbol":"\u20a6","name":"Nigerian naira"},
  {"symbol":"C$","name":"Nicaraguan c\u00f3rdoba"},
  {"symbol":"kr","name":"Norwegian krone"},
  {"symbol":"NRs","name":"Nepalese rupee"},
  {"symbol":"NZ$","name":"New Zealand dollar"},
  {"symbol":"OMR","name":"Omani rial"},
  {"symbol":"B./","name":"Panamanian balboa"},
  {"symbol":"S/.","name":"Peruvian nuevo sol"},
  {"symbol":"K","name":"Papua New Guinean kina"},
  {"symbol":"\u20b1","name":"Philippine peso"},
  {"symbol":"Rs.","name":"Pakistani rupee"},
  {"symbol":"z\u0142","name":"Polish zloty"},
  {"symbol":"\u20b2","name":"Paraguayan guarani"},
  {"symbol":"QR","name":"Qatari riyal"},
  {"symbol":"L","name":"Romanian leu"},
  {"symbol":"din.","name":"Serbian dinar"},
  {"symbol":"R","name":"Russian ruble"},
  {"symbol":"SR","name":"Saudi riyal"},
  {"symbol":"SI$","name":"Solomon Islands dollar"},
  {"symbol":"SR","name":"Seychellois rupee"},
  {"symbol":"SDG","name":"Sudanese pound"},
  {"symbol":"kr","name":"Swedish krona"},
  {"symbol":"S$","name":"Singapore dollar"},
  {"symbol":"\u00a3","name":"Saint Helena pound"},
  {"symbol":"Le","name":"Sierra Leonean leone"},
  {"symbol":"Sh.","name":"Somali shilling"},
  {"symbol":"$","name":"Surinamese dollar"},
  {"symbol":"LS","name":"Syrian pound"},
  {"symbol":"E","name":"Swazi lilangeni"},
  {"symbol":"\u0e3f","name":"Thai baht"},
  {"symbol":"TJS","name":"Tajikistani somoni"},
  {"symbol":"m","name":"Turkmen manat"},
  {"symbol":"DT","name":"Tunisian dinar"},
  {"symbol":"TRY","name":"Turkish new lira"},
  {"symbol":"TT$","name":"Trinidad and Tobago dollar"},
  {"symbol":"NT$","name":"New Taiwan dollar"},
  {"symbol":"TZS","name":"Tanzanian shilling"},
  {"symbol":"UAH","name":"Ukrainian hryvnia"},
  {"symbol":"USh","name":"Ugandan shilling"},
  {"symbol":"US$","name":"United States dollar"},
  {"symbol":"$U","name":"Uruguayan peso"},
  {"symbol":"UZS","name":"Uzbekistani som"},
  {"symbol":"Bs","name":"Venezuelan bolivar"},
  {"symbol":"\u20ab","name":"Vietnamese dong"},
  {"symbol":"VT","name":"Vanuatu vatu"},
  {"symbol":"WS$","name":"Samoan tala"},
  {"symbol":"CFA","name":"Central African CFA franc"},
  {"symbol":"EC$","name":"East Caribbean dollar"},
  {"symbol":"SDR","name":"Special Drawing Rights"},
  {"symbol":"CFA","name":"West African CFA franc"},
  {"symbol":"F","name":"CFP franc"},
  {"symbol":"YER","name":"Yemeni rial"},
  {"symbol":"R","name":"South African rand"},
  {"symbol":"ZK","name":"Zambian kwacha"},
  {"symbol":"Z$","name":"Zimbabwean dollar"}
]